document.addEventListener('DOMContentLoaded', function () {
    const boton = document.querySelector('.filtro_rapido_wrapper');
    const facetsWrapper = document.querySelector('.facets.facets-vertical-sort');
    const facetsWrapperMob = document.querySelector('.facets-vertical');
    

    const isVisible = (el) => {
    if (!el) return false;
    // hidden attribute o aria-hidden
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;

    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    // Si no ocupa espacio, normalmente está oculto
    if (el.offsetParent === null) return false;

    return true;
  };

  const target = isVisible(facetsWrapper) ? facetsWrapper : false;

  if (target) {
    target.append(boton);
  } else {
    console.warn('No se encontró contenedor visible ni facetsWrapperMob.');
  }

  });